const state = {
  userLogin_: [],
}
const getters = {
  getUserLogin: state => {
    return state.userLogin_
  }
}
const mutations = {
  setLanguage(state, value) {
    state.userLogin_ = value
  }
}
const actions = {
  setUserLogin({commit}, value) {
    commit('setUserLogin', value)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/Login.js